//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'SubscribeForm',
  data: () => ({
    email: null,
    message: null,
    subscribed: false,
    loading: false
  }),
  watch: {
    email () {
      this.message = null
    }
  },
  methods: {
    async submit () {
      if (!this.email) return

      this.loading = true
      const response = await this.$store.dispatch('session/SUBSCRIBE', this.email)
      if (response.subscribed) {
        this.subscribed = true
        this.$store.commit('store/SET_EMAIL', this.email)
        this.message = 'Welcome to our mailing list!'
      } else if ('valid' in response && !response.valid) {
        this.message = 'Please enter a valid email address and try again.'
      } else {
        this.message = 'An error occurred, please try again.'
      }
      this.loading = false
    }
  }
}
